import classnames from 'classnames';
import React from 'react';
import './CenteredContent.scss';

function CenteredContent(props) {
  const { className, contentClassName, children } = props;

  return (
    <div className={classnames('centered-content', className)}>
      <div
        className={classnames('centered-content__content', contentClassName)}
      >
        {children}
      </div>
    </div>
  );
}

export default React.memo(CenteredContent);
